<template>
	<a :href="href" :target="trigger.button_target" :class="linkType"><div v-if="linkType === 'button'" class="hover-title">{{ trigger.button_text }}</div><span class="icon fa" :class="trigger.button_icon"></span>{{ linkType === 'link' ? trigger.button_text : '' }}</a>
</template>

<script>

import RowTemplateBuilder from '../../utils/RowTemplateBuilder';

const Builder = new RowTemplateBuilder();

export default {

	props: {
		trigger: {
			required: true,
			type: Object,
		},
		module: {
			type: Object,
			default: () => ({}),
		},
		linkType: {
			type: String,
			default: 'button', // Options: button, link
		},
		row: {
			type: Object,
			default: () => ({}),
		},
	},

	computed: {

		href() {
			Builder.setTemplate(this.trigger.url);
			return Builder.convertRow(this.row);
		},

	},

};

</script>
